<template>
	<div class="hd-moa-frame-virus-package js-moa-frame-virus-package">
		<div class="hd-moa-frame-virus-package__bg"></div>
		<div class="hd-moa-frame-virus-package__bg-cells"></div>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-virus-package {
		@include absolute-lr-0();
		@include box(100%);

		&__bg {
			@include absolute-lr-0();
			@include box(100%);
			background: url('../../assets/images/moa-vitamin-release.png');
			@include background-cover();
			background-position: center;
			@include fade-out();
		}
		
		&__bg-cells {
			@include absolute-lr-0();
			@include box(100%);
			background: url('../../assets/images/moa-vitamin-release-cell.png');
			@include background-cover();
			background-position: center;
			@include animation-float-mini();
			@include fade-out();
		}

		// Animation 
		&[data-state="animation-ready"] {
			.hd-moa-frame-virus-package__bg {
				@include transition-frame-fade-in();
			}

			.hd-moa-frame-virus-package__bg-cells {
				@include transition-frame-fade-in();
				transition-delay: 0.25s;
			}
		}
	}
</style>

